import React from "react"
import { ThemeProvider } from "styled-components"

import { lightTheme, darkTheme } from "../Theme/theme"

export const ColorModeContext = React.createContext()

export const ColorModeProvider = ({ children }) => {

  const [mode, setMode] = React.useState("light")

  React.useEffect(() => {

    const stored = localStorage.getItem("colorMode")

    if (stored) {
      setMode(stored)
      return
    }

    const prefersDark =
      window.matchMedia("(prefers-color-scheme: dark)").matches

    setMode(prefersDark ? "dark" : "light")

  }, [])

  const toggle = () => {

    const newMode = mode === "dark" ? "light" : "dark"

    setMode(newMode)

    localStorage.setItem("colorMode", newMode)

  }

  const theme = mode === "dark" ? darkTheme : lightTheme

  return (

    <ColorModeContext.Provider
      value={{ mode, toggle }}
    >

      <ThemeProvider theme={theme}>

        {children}

      </ThemeProvider>

    </ColorModeContext.Provider>

  )

}